import { jsx as _jsx } from "react/jsx-runtime";
export var BackToTopIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b;
    var iconSize = {
        sm: 'size-4',
        md: 'size-6',
        lg: 'size-8',
    };
    return (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24', strokeWidth: '1.5', stroke: 'currentColor', className: iconSize[size], children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18' }) }));
};
